<div *ngIf="!isVisible" class="hidden login-panel flex flex-column px-4 py-4 bg-cover bg-norepeat"
     [ngStyle]="{'background-image': imageSrc ? 'url(' + imageSrc + ')' : '', 'background-color': imageSrc ? '' : colorCode}">
  <div class="login-header flex align-items-center">
    <span #loginTitle class="block text-color-login font-semibold" id="title-img">{{pageLogin?.title}}</span>
  </div>

  <div class="login-content flex align-items-center">
    <div class="login-content-scroll text-color-login text-3xl" id="content">
      <div #loginContent [innerHTML]="pageLogin?.content | safeComment"></div>
    </div>
  </div>

  <div class="login-footer flex align-items-center gap-5">
    <span class="text-color-login font-semibold" id="desc" [innerHTML]="pageLogin?.description"></span>
    <div class="footer-color-login font-semibold">
      <ng-container *ngFor="let reseaux of pageLogin?.pageLoginReseauSocials">
        <a *ngIf="reseaux?.display" [href]="reseaux.url" target="_blank">
          <i *ngIf="reseaux?.key === 'LINKEDIN'" class="pi pi-linkedin text-lg p-2 surface-overlay border-circle ml-3 cursor-pointer"></i>
          <i *ngIf="reseaux?.key === 'YOUTUBE'" class="pi pi-youtube text-2lg p-2 surface-overlay border-circle ml-3 cursor-pointer"></i>
          <i *ngIf="reseaux?.key === 'TWITTER'" class="fa-brands fa-x-twitter text-lg p-2 surface-overlay ml-3 border-circle cursor-pointer"></i>
          <i *ngIf="reseaux?.key === 'INSTAGRAM'" class="pi pi-instagram text-lg p-2 surface-overlay border-circle ml-3 cursor-pointer"></i>
          <i *ngIf="reseaux?.key === 'FACEBOOK'" class="pi pi-facebook text-lg p-2 surface-overlay border-circle ml-3 cursor-pointer"></i>
        </a>
      </ng-container>
    </div>
  </div>
</div>

<div *ngIf="isVisible" class="hidden h-full flex flex-column justify-content-between align-items-center px-6 py-6 bg-cover bg-norepeat"
     [ngStyle]="{'background-image': imageSrc ? 'url(' + imageSrc + ')' : '', 'background-color': imageSrc ? '' : colorCode}">
</div>
